export const CompanyAdminEndPoints = {
  readRegisteredProjects: {
    url: (company) => `/rest/v1/readRegisteredProjects/${company}`,
    method: "GET",
  },
  readProcurementLogsViews: {
    url: (company) => `/rest/v1/readProcurementLogsViews/${company}`,
    method: "GET",
  },
  getSampleProcurementLogsViews: {
    url: (company) => `/rest/v1/getSampleProcurementLogsViews/${company}`,
    method: "POST",
  },
  createProcurementLogsViews: {
    url: (company) => `/rest/v1/createProcurementLogsViews/${company}`,
    method: "POST",
  },
  updateProcurementLogsViews: {
    url: (company) => `/rest/v1/updateProcurementLogsViews/${company}`,
    method: "PUT",
  },
  deleteProcurementLogsViews: {
    url: (company) => `/rest/v1/deleteProcurementLogsViews/${company}`,
    method: "DELETE",
  },
  companyAdminPage: {
    url: (company) => `/rest/v1/companyAdminPage/${company}`,
    method: "GET",
  },
  updateCompanyWorkingDays: {
    url: (company) => `/rest/v1/updateCompanyWorkingDays/${company}`,
    method: "PUT",
  },
  updateCompanyNonWorkingDays: {
    url: (company) => `/rest/v1/updateCompanyNonWorkingDays/${company}`,
    method: "PUT",
  },

  //COMPANY LOGO ENDPOINTS
  uploadCompanyLogo: {
    url: (company) => `/rest/v1/uploadCompanyLogo/${company}`,
    method: "POST",
  },
  updateCompanyLogo: {
    url: (company) => `/rest/v1/updateCompanyLogo/${company}`,
    method: "PUT",
  },
  deleteCompanyLogo: {
    url: (company) => `/rest/v1/deleteCompanyLogo/${company}`,
    method: "DELETE",
  },
  getCompanyLogo: {
    url: (company) => `/rest/v1/getCompanyLogo/${company}`,
    method: "GET",
  },
};
